import { createContext, useContext, useEffect, useState } from "react"
import { getFileExtension } from "@minohealth/common/utils/files"

import { FaRegFileAlt, FaRegFilePdf, FaRegFileWord } from "react-icons/fa"
import { IoMdClose } from 'react-icons/io'
import { BiLoaderAlt } from 'react-icons/bi'

import "./chat-file-card.css"

/** @param {{children: React.ReactNode, loading?: boolean, fullwidth?: boolean}} props */
export default function ChatFileCard({ children, loading, fullwidth }) {
  const [name, setName] = useState("")
  const extension = getFileExtension(name).toLowerCase()

  return (
    <chatFileCardContext.Provider value={{name, extension, loading, setName}}>
      <div
        className="chat-file-card"
        title={name}
        data-file-type={extension}
        data-loading={loading}
        data-full-width={fullwidth}
      >
        {children}
      </div>
    </chatFileCardContext.Provider>
  )
}

ChatFileCard.Name = ChatFileCardName
ChatFileCard.Badge = ChatFileCardBadge
ChatFileCard.Icon = ChatFileCardIcon
ChatFileCard.RemoveBtn = ChatFileCardRemoveBtn

/** A short label beside the file name. @param {{children: React.ReactNode, title?: string}} props */
function ChatFileCardBadge({ children, title }) {
  return (<span className="chat-file-card__badge" title={title}>{children}</span>)
}

/** @param {{children: string}} props */
function ChatFileCardName({ children }) {
  const { setName, loading } = useContext(chatFileCardContext)

  useEffect(() => {
    if(typeof children !== "string") {
      throw new Error(`Expected children to be a string, got ${typeof children}`)
    }

    setName(children)
  }, [children, loading])

  return (<p className="chat-file-card__file-name">{children}</p>)
}

function ChatFileCardIcon() {
  const { extension, loading } = useContext(chatFileCardContext)

  return (
    <div className="chat-file-card__file-icon">
      {loading
        ? <BiLoaderAlt className="spin" style={{"--duration": "1s"}} />
        : <FileIcon extension={extension} />
      }
    </div>
  )
}

/** @param {{extension: string}} props */
function FileIcon({ extension }) {
  switch(extension) {
    case "pdf":
      return <FaRegFilePdf />
    case "doc":
    case "docx":
      return <FaRegFileWord />
    default:
      return <FaRegFileAlt />
  }
}

/** @param {React.ButtonHTMLAttributes<HTMLButtonElement>} props */
function ChatFileCardRemoveBtn({ className = "", ...restOfProps}) {
  return (
    <button
      className={"chat-file-card__remove-btn " + className}
      {...restOfProps}
    >
      <IoMdClose />
    </button>
  )
}

const chatFileCardContext = createContext({})